if (!customElements.get('judge-me-rating-summary')) {
  class JudgeMeRatingSummary extends HTMLElement {
    connectedCallback() {
      this.textElement = this.querySelector('[data-judgeme-rating-text]');
      this.sourceElement = this.querySelector('[data-judgeme-rating-source]');

      this.render();

      if (this.sourceElement) {
        this.observer = new MutationObserver(() => this.render());
        this.observer.observe(this.sourceElement, {
          attributes: true,
          childList: true,
          subtree: true
        });
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    render() {
      if (!this.textElement) {
        return;
      }

      const badge = this.sourceElement?.querySelector('.jdgm-prev-badge');
      const rating = this.toNumber(badge?.dataset.averageRating) || this.toNumber(this.dataset.rating);
      const maxRating = this.toNumber(this.dataset.maxRating) || 5;
      const reviewCount = this.toNumber(badge?.dataset.numberOfReviews) || this.toNumber(this.dataset.reviewCount);

      if (!rating || !reviewCount) {
        this.hidden = true;
        return;
      }

      const text = `${this.formatRating(rating)} / ${this.formatRating(maxRating)} · ${this.formatReviewCount(reviewCount)}`;

      this.hidden = false;
      this.textElement.textContent = text;
      this.setAttribute('aria-label', text);
    }

    toNumber(value) {
      if (value === undefined || value === null || value === '') {
        return null;
      }

      const number = Number(String(value).replace(/,/g, ''));
      return Number.isFinite(number) ? number : null;
    }

    formatRating(value) {
      const rounded = Math.round(value * 10) / 10;
      return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1);
    }

    formatReviewCount(count) {
      const locale = document.documentElement.lang || undefined;
      const formattedCount = new Intl.NumberFormat(locale).format(count);
      const template = count === 1 ? this.dataset.reviewOne : this.dataset.reviewOther;

      return template ? template.replace('[count]', formattedCount) : `${formattedCount} reviews`;
    }
  }

  customElements.define('judge-me-rating-summary', JudgeMeRatingSummary);
}
